// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationSuccess: React.FC<{ width?: number; height?: number }> = ({ width = 18, height = 18 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9 18c4.957 0 9-4.043 9-9s-4.043-9-9-9-9 4.043-9 9 4.043 9 9 9Zm2.953-10.512-2.812 4.5c-.141.211-.387.387-.668.387a.82.82 0 0 1-.703-.352l-1.688-2.25a.81.81 0 0 1 .176-1.16.81.81 0 0 1 1.16.176l.95 1.266 2.179-3.48a.845.845 0 0 1 1.16-.247c.387.246.527.774.246 1.16Z"
            />
        </svg>
    );
};

export default React.memo(NotificationSuccess);
